import {OrderService, MovieService, AuthService, EcomTrackingService} from 'hasta-la-vista-middleware-api/service'
import badgeConfig from '../../pages/user/badgeConfig';
import Vue from 'vue'
export default {

    data(){
        return {
            loading: true,
            donationDialog: false,
            loadingBackOrder:false,
            order: null,
            concessionGroups: null,
            currentIndex: 0,
            // these are the tests if they return true these concession groups will show
            concessionsLogic: {
                "3D Glasses": (val)=>!!~val.toLowerCase().indexOf('3d') && !~val.toLowerCase().indexOf('imax'),
                "Imax 3D Gl": (val)=>!!~val.toLowerCase().indexOf('imax') && !!~val.toLowerCase().indexOf('3d'),
            },
            movies: null,
            promoCombos: [],
            rewards: [],
            glassesDialog: false,
            donationDialog: false,
            badgeConfig: badgeConfig,
            lastConcession: false,
            loadingUpdateOrder: false,
        }
    },

    computed: {
        experience(){
            return this.order && this.order.Experiences ? this.order.Experiences.map((e)=> {
                return e ? e.name : undefined
            }).join() : "2D"
        },
        concessionsFiltered(){
            return this.concessionGroups ? this.concessionGroups.filter((group)=> {
                var passed = false;
                if(group.Name != 'Subs') {
                    if (!this.concessionsLogic.hasOwnProperty(group.Name)) {
                        return !this.concessionsLogic.hasOwnProperty(group.Name);
                    }

                    for (var i = 0; i < this.order.Experiences.length; i++) {
                        var exp = this.order.Experiences[i].name;
                        if (this.concessionsLogic[group.Name](exp)) {
                            passed = true;
                        }
                    }

                    return passed
                } else {
                    return passed
                }
            }) : this.concessionGroups
        },

        concessionsRaw(){
            return this.concessionGroups ? this.concessionGroups.reduce((c, g)=> {
                return c = c.concat(g.ConcessionItems);
            }, []) : [];
        },
    },

    methods: {

        getSortedConcessions(items){
            return  items.sort((a,b)=>a.Description < b.Description ? -1 : (a.Description > b.Description ? 1 : 0));

        },

        getBadgeIcon(reward){
            for (var i = 0; i < this.badgeConfig.length; i++) {
                let badgeConfig = this.badgeConfig[i];
                if (badgeConfig.test(reward))
                    return badgeConfig;

            }
        },

        isActive(index){
            return index == this.currentIndex
        },

        setConcession(concession, qty){
            this.order.setConcession(concession, qty);
        },

        updateOrder(){
            // console.log(this.order.modified)
            console.log("updateOrder", this.order)
            
            if (!this.order.modified) {
                this.hasConsessions = true;
                OrderService.saveOrderConcessionsOnly().then((order)=> {
                    let filmTitle = order.Sessions[0].FilmTitle
                    console.log(filmTitle)
                    Promise.resolve(EcomTrackingService.doDataLayerCommitBasket(order._ticketFlow, filmTitle)).then((result) => {
                        this.$router.push(`/booking/3${this.$route.params.festival_id ? '/film-festival/' + this.$route.params.festival_id : ''}`)
                    })
                })
            } else {
                this.loadingUpdateOrder = true;
                OrderService.saveOrderConcessionsOnly().then((order)=> {
                    let filmTitle = order.Sessions[0].FilmTitle
                    console.log(filmTitle)
                    Promise.resolve(EcomTrackingService.doDataLayerCommitBasket(order._ticketFlow, filmTitle)).then((result) => {
                        this.$router.push(`/booking/3`);
                    })
                    
                })
            }
        },

        nextConsession(group, index) {
            this.currentIndex = index;
            this.currentConcession = index + 1

            // console.log(this.concessionsFiltered, index + 1)

            if (index + 1 == this.concessionsFiltered.length) {
                // console.log(this.currentIndex)
                // console.log(this.currentConcession)
                this.lastConcession = true
                if (group.Name == '3D Glasses' || group.Name == 'Imax 3D Gl') {
                    this.toggleConcessionDialogs('glasses', group, index)
                } else if (group.Name == 'Donations') {
                    this.toggleConcessionDialogs('donate', group, index)
                } else {
                    this.updateOrder()
                }
            } else {
                if (group.Name == '3D Glasses' || group.Name == 'Imax 3D Gl') {
                    this.toggleConcessionDialogs('glasses', group, index)
                } else if (group.Name == 'Donations') {
                    this.toggleConcessionDialogs('donate', group, index)
                } else {
                    this.nextAccordionIndex(index + 1)
                }
                window.scroll({top: 0})
                Vue.nextTick(()=> {
                    this.$refs.acorn.forEach((el)=> {
                        if (el.$el.classList.contains('accordian--active')) {
                            window.scroll(0, el.$el.offsetTop)
                        }
                    })
                })
            }

        },

        toggleConcessionDialogs(dialog, group, index) {
            let hasConcession = false
            group.ConcessionItems.forEach((el)=> {
                if (el.Quantity > 0) {
                    hasConcession = true
                }
            })
            if (hasConcession) {
                if (this.lastConcession) this.updateOrder()
                else this.nextAccordionIndex(index + 1)
            } else {
                if (dialog == 'glasses') this.glassesDialog = true
                if (dialog == 'donate') this.donationDialog = true
            }
        },

        nextAccordionIndex(index) {
            if (index == this.concessionsFiltered.length) {
                this.donationDialog = false
            }
            Vue.nextTick(()=> {
                if (this.glassesDialog) this.glassesDialog = false
                if (this.donationDialog) this.donationDialog = false
                if (index == this.concessionsFiltered.length) {
                    this.updateOrder()
                } else {
                    this.currentIndex = index;
                }
            })
        },


        applyReward(linked, reward){
            var concession = this.concessionsRaw.find((c)=>c.HeadOfficeItemCode == reward.VistaID)
            if (concession) {
                var comboConcession = Object.assign({}, concession, {
                    PriceInCents: 0,
                    Description: reward.Name,
                    RecognitionId: reward.RecognitionID,
                    RecognitionSequenceNumber: reward.SequenceNumber,
                })
                this.order.setConcession(comboConcession, linked ? 1 : 0);
            }
        }
    },

    created() {
        this.loading = true;
        Promise.all([OrderService.getOrder(), OrderService.getConcessionsForCinema(), MovieService.getMovies(), AuthService.getRewards()]).then(([order,concessionGroups,movies,rewards])=> {
            this.order = order;

            this.concessionGroups = concessionGroups
                .sort((a, b)=> {
                    return +(!b.Name.localeCompare('Kids')); // specifically ensure that Kids Glasses is First
                })
                .sort((a, b)=> {
                    if(a.ConcessionItems){
                        a.ConcessionItems = this.getSortedConcessions(a.ConcessionItems);
                    }
                    return +(!a.Name.localeCompare('Combos')); // specifically ensure that Combos is last
                })
                .sort((a, b)=> {

                    return +(!a.Name.localeCompare('Donations')); // specifically ensure that donations is last after combos
                });
            this.movies = movies;

            this.rewards = rewards.ConcessionList ? rewards.ConcessionList.map((b)=> {
                b.badge = this.getBadgeIcon(b);
                b.linked = false;
                return b;
            }) : [];

            this.loading = false;

            let OrderMovies = order.Sessions.reduce((c, s)=> {
                c.push(s.movie.id);
                return c;
            }, []);
            this.concessionsRaw.map((item)=> {
                item.movie = movies.findById(item.DescriptionAlt);
                item.isRelatedPromo = item.DescriptionAlt ? Boolean(~OrderMovies.indexOf(item.DescriptionAlt)) : false;
                let concession = this.order.Concessions.find((c)=>c.Id == item.Id);
                item.Quantity = concession ? concession.Quantity : 0;
                return item;
            });

        })
    },

    mounted(){
        window.scroll({top: 0, left: 0})
    }

}


// WEBPACK FOOTER //
// ./src/components/booking/extras/extras.js